import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fi from './locales/fi.json';
import fiTampere from './locales/fi-tampere.json';
import en from './locales/en.json';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: true,
        fallbackLng: 'fi',
        interpolation: {
            escapeValue: false,
        },
        resources: {
            fi: {
                translation: fi
            },
            'fi-tampere': {
                translation: fiTampere
            },
            en: {
                translation: en
            }
        }
    });

export default i18n;
